import { useEffect } from "react";
import { getTracking } from "./tracking";

const TrackingLoaderComponent = () => {
  useEffect(() => {
    getTracking();
  }, []);
  return null;
};

export default TrackingLoaderComponent;
